import {useState, useEffect, useRef} from 'react';
import Form from "react-bootstrap/Form";
import './_size-variable.scss';
import VButton from "../../../v-button/v-button";
import VStore from "../../../../store";

export default function SizeVariable() {

    const {screenshotMode, currentFilter, sizeRange, changeSizeRange, setCurrentFilter} = VStore();

    const sizeList = [
        0,
        500,
        1000,
        1500,
        2000,
        2500,
        3000,
        3500,
    ];

    const [minSize, setMinSize] = useState(sizeRange.min);
    const [maxSize, setMaxSize] = useState(sizeRange.max);
    const timer = useRef<any>(null)

    const maxSizeList = [
        0,
        ...sizeList.filter(size => size > minSize),
    ]

    function toSquareFeet(size: number) {
        return size + ' sqft';
    }

    function applySizeRange() {
        changeSizeRange({
            min: minSize,
            max: maxSize,
        });
        setCurrentFilter('');
    }

    function onMouseEnter() {
        clearTimeout(timer.current);
    }

    function onMouseLeave() {
        timer.current = setTimeout(() => {
            setCurrentFilter('');
        }, 1000);
    }

    useEffect(() => {
        if (minSize > maxSize && maxSize !== 0) {
            setMaxSize(0);
        }
    }, [minSize])

    useEffect(() => {
        if (currentFilter === 'size') {
            setMinSize(sizeRange.min);
            setMaxSize(sizeRange.max);
            timer.current = setTimeout(() => {
                setCurrentFilter('');
            }, 3000);
        }

    }, [currentFilter])


    return (<div className={"size-variable" + (currentFilter === 'size' && !screenshotMode ? ' show' : '')}
                 onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <div className='d-flex pb-3'>
            <div className='col-5'>
                <p>Minimum</p>
                <Form.Select aria-label="Default select example"
                             onChange={(e) => setMinSize(parseInt(e.target.value))}
                             value={minSize}
                >
                    {
                        sizeList.map((size, index) => {
                            return <option key={index} value={size}>
                                {
                                    size !== 0 ? toSquareFeet(size) : 'Any'
                                }
                            </option>
                        })
                    }
                </Form.Select>
            </div>
            <div className='col-2 d-flex justify-content-center align-items-end p-2'>-</div>
            <div className='col-5'>
                <p>Maximum</p>
                <Form.Select aria-label="Default select example"
                             onChange={(e) => setMaxSize(parseInt(e.target.value))}
                             value={maxSize}
                >
                    {
                        maxSizeList.map((size, index) => {
                            return <option key={index} value={size}>
                                {
                                    size !== 0 ? toSquareFeet(size) : 'Any'
                                }
                            </option>
                        })
                    }
                </Form.Select>
            </div>
        </div>
        <VButton content='Apply' width='100%' className='pt-2 pb-2' onClick={applySizeRange}></VButton>
    </div>);
}
